import Http from "../engine/Http";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";
import { Material } from "./MaterialApi";
export interface PricingGroup {
  id: number;
  name: string;
}

export interface PricingGroupElement {
  pricingGroup: PricingGroup;
  material: Material;
  unitProfitMargin: number;
  unitCustomerPrice?: number;
}

const usePricingGroupApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchPricingGroups = () => Http.get(`/api/pricing-groups`, [ authenticationHeader ]);

  const fetchCustomerPricingGroup = (customerId: number): Promise<PricingGroup> =>
    Http.get(`/api/customers/${customerId}/pricing-group`, [ authenticationHeader ], [200, 404]);

  const fetchPricingGroupElements = (pricingGroupId: number): Promise<PricingGroupElement[]> =>
    Http.get(`/api/pricing-groups/${pricingGroupId}/elements`, [ authenticationHeader ]);
  
  const assignPricingGroupToCustomer = (customerId: number, pricingGroupId: number) =>
    Http.put(`/api/customers/${customerId}/pricing-group`, { id: pricingGroupId }, [ authenticationHeader ]);

  const updatePricingGroupElementUnitCustomerPrice = (pricingGroupId: number, pricingGroupElementId: number, unitCustomerPrice: number) =>
    Http.patch(`/api/pricing-groups/${pricingGroupId}/elements/${pricingGroupElementId}`, { unitCustomerPrice }, [ authenticationHeader ]);

  return {
    fetchPricingGroups,
    fetchCustomerPricingGroup,
    fetchPricingGroupElements,
    assignPricingGroupToCustomer,
    updatePricingGroupElementUnitCustomerPrice
  };
};

export default usePricingGroupApi;